import type { BoggleRunLedgerEntry } from '~/boggle/engine/standard/types'

import { isAcceptedWordEntry } from './checkTypes'

export function acceptedIndicesThrough(
  ledger: readonly BoggleRunLedgerEntry[],
  index: number,
) {
  const out: number[] = []
  for (let i = 0; i <= index; i++) {
    if (isAcceptedWordEntry(ledger[i])) {
      out.push(i)
    }
  }
  return out
}

/** First accepted-word index where Explorer newly reaches a clear streak. */
export function explorerCompletionIndex(
  ledger: readonly BoggleRunLedgerEntry[],
  streakRequired = 10,
): number | null {
  const streak: Array<{ col: number; row: number }> = []
  let completion: number | null = null
  for (let i = 0; i < ledger.length; i++) {
    const entry = ledger[i]
    if (!isAcceptedWordEntry(entry)) {
      continue
    }
    for (const position of entry.clearedPositions) {
      const repeated = streak.some(
        cell => cell.col === position.col && cell.row === position.row,
      )
      if (repeated) {
        streak.length = 0
        streak.push({ col: position.col, row: position.row })
      } else {
        streak.push({ col: position.col, row: position.row })
      }
      if (streak.length >= streakRequired && completion === null) {
        completion = i
      }
    }
  }
  return completion
}

export function ledgerHasAnyCorrection(ledger: readonly BoggleRunLedgerEntry[]) {
  return ledger.some(entry => entry.kind === 'correction')
}
